/** Mirrors `PE_CLOSES_DAYS_BEFORE_START` in `registration/constants/iperia.py`. */
const PE_CLOSES_DAYS_BEFORE_START = 3;

const AWAITING_PARENT = new Set(["awaiting_pe_signature", "pe_signature_expired"]);

export const IPERIA_PE_SIGNATURE_CLOSED_LABEL = "Signature PE impossible";

type PeWindow = {
    workflow_status?: string | null;
    pe_signature_last_day?: string | null;
    bi_pe_signed_at?: string | null;
};

/** The parent can no longer sign: the window closed at the end of J-3 before the session. */
export function iperiaPeSignatureClosed(extension: PeWindow | null | undefined): boolean {
    if (!extension || extension.bi_pe_signed_at || !extension.pe_signature_last_day) return false;
    if (!AWAITING_PARENT.has(extension.workflow_status ?? "")) return false;
    return new Date(extension.pe_signature_last_day).getTime() < Date.now();
}

export function iperiaPeSignatureClosedMessage(lastDay: string | null | undefined): string {
    const day = lastDay
        ? new Date(lastDay).toLocaleDateString("fr-FR", { timeZone: "Europe/Paris" })
        : null;
    const when = day ? ` depuis le ${day}` : "";
    return `Le parent employeur ne peut plus signer${when}. Le délai se ferme ${PE_CLOSES_DAYS_BEFORE_START} jours avant le début de formation.`;
}
